import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { portalHomeUrlTree } from './portal-home';

export type AuthGateResult = boolean | UrlTree;

/**
 * Shared auth-gate rules for session restore and route guards.
 * Network failures with a stored session allow the shell; 401/403 still sign out.
 */
export async function resolveAuthGuardAccess(
  auth: AuthService,
  router: Router,
): Promise<AuthGateResult> {
  await auth.whenSessionReady();
  if (auth.sessionOffline()) {
    return auth.hasStoredSessionCredentials() ? true : router.createUrlTree(['/login']);
  }
  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }
  if (auth.needsRoleChoice()) {
    return router.createUrlTree(['/login']);
  }
  return true;
}

export async function resolveGuestGuardAccess(
  auth: AuthService,
  router: Router,
): Promise<AuthGateResult> {
  await auth.whenSessionReady();
  if (auth.sessionOffline() && auth.hasStoredSessionCredentials()) {
    if (auth.needsRoleChoice()) {
      return true;
    }
    return portalHomeUrlTree();
  }
  if (!auth.isAuthenticated()) {
    return true;
  }
  if (auth.needsRoleChoice()) {
    return true;
  }
  return portalHomeUrlTree();
}
